import { Box, Link, Stack, Typography, useTheme } from '@mui/material';
import { HotAirBalloon } from 'Images';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useContext } from 'react';
import { OTPLoginContext } from 'Context/OTPLoginContext';
import { mokedNumber } from 'Config';
import { TitleImageAndText } from 'Components/TitleImageAndText';
import { ArrowButton } from 'Modules/OTPLogin/ArrowButton';
import { msalInstance } from 'index';

export const LoginInformation = () => {
  const isDesktop = useIsDesktop();
  const { step, setStep } = useContext(OTPLoginContext);
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.OTP_Login
  ).loginInformation;
  const palette = useTheme().palette;

  return (
    <Stack
      gap={isDesktop ? '56px' : '40px'}
      maxWidth={isDesktop ? '611px' : '285px'}
      textAlign={'center'}
    >
      <Stack alignItems={'center'}>
        <TitleImageAndText
          title={dictionary.title}
          image={HotAirBalloon}
          testSx={{ whiteSpace: 'nowrap' }}
        />
        <Stack gap={isDesktop ? '36px' : '12px'} alignItems={'center'}>
          <Typography variant={'body3'}>{dictionary.subTitle}</Typography>
          <Box
            width={isDesktop ? '234px' : '208px'}
            height={isDesktop ? '46px' : '44px'}
          >
            <ArrowButton
              buttonVariant={'primary1'}
              arrowColor={'#fff'}
              typographyVariant={'body4'}
              arrowPosition={'left'}
              onClick={() => {
                document.location = '/';
              }}
              text={dictionary.personalArea}
            />
          </Box>
        </Stack>
      </Stack>
      <Stack alignItems={'center'} gap={isDesktop ? '24px' : '12px'}>
        <Stack gap={isDesktop ? '12px' : '0px'} alignItems={'center'}>
          <Typography variant={'body1'} component='h4'>
            {dictionary.personalAreaAccess}
          </Typography>
          <Typography variant={'body3'}>
            {dictionary.requestAbilityWithValidation}
          </Typography>
        </Stack>
        <Box
          height={isDesktop ? '46px' : '44px'}
          width={isDesktop ? '234px' : '208px'}
        >
          <ArrowButton
            onClick={() => setStep(step + 1)}
            text={dictionary.continueValidation}
            arrowColor={palette.primary.main}
            buttonVariant={'secondary1'}
            typographyVariant={'body4'}
            arrowPosition={'left'}
          />
        </Box>
      </Stack>
      <Stack alignItems={'center'} gap={isDesktop ? '12px' : '0px'}>
        <Typography variant={'body3'}>{dictionary.noUserFile}</Typography>
        <Stack direction={'row'} justifyContent={'center'}>
          <Typography variant={'body3'}>
            {dictionary.happyToHelp}
            {isDesktop ? (
              mokedNumber
            ) : (
              <Link underline={'always'} href={`tel:${mokedNumber}`}>
                {mokedNumber}
              </Link>
            )}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
